import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { XCircle, QrCode } from "lucide-react";
import { Button } from "@/components/ui/button";

export interface DuplicateScanState {
  message: string;
  payload: string;
}

export function ScanFailedPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const duplicateScan = (location.state as { duplicateScan?: DuplicateScanState } | null)
    ?.duplicateScan;

  const handleContinuePatrol = () => {
    navigate("/patrol/scan");
  };

  if (!duplicateScan) {
    return (
      <div className="flex flex-col h-full items-center justify-center p-6 bg-gray-50">
        <p className="text-gray-500 mb-4">No scan failure details found.</p>
        <Button onClick={() => navigate("/patrol/scan")} variant="outline">
          Back to scanner
        </Button>
      </div>
    );
  }

  const { message, payload } = duplicateScan;

  return (
    <div className="flex flex-col h-full bg-gray-50">
      <div className="flex-1 overflow-y-auto p-4">
        <div className="flex flex-col items-center mb-6">
          <XCircle className="h-16 w-16 text-red-600 mb-3" aria-hidden />
          <h2 className="text-xl font-semibold text-gray-900">Scan Failed</h2>
          <p className="text-gray-600 text-sm">Duplicate scan</p>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 p-4 space-y-3 mb-6">
          <p className="text-gray-700 text-sm">{message}</p>
          <div className="flex items-center gap-3">
            <QrCode className="h-5 w-5 text-gray-500 flex-shrink-0" />
            <p className="text-gray-700 text-sm font-mono">{payload}</p>
          </div>
        </div>

        <div className="space-y-3">
          <Button
            onClick={handleContinuePatrol}
            className="w-full flex items-center justify-center"
          >
            Continue Patrol
          </Button>
        </div>
      </div>
    </div>
  );
}
